module.exports = __webpack_public_path__ + "static/media/light_delphi.e7c48517.png";